import { fabric } from 'fabric';

import CanvasHandler from './CanvasHandler';
import { FabricObject } from "../types/FabricCustomType";
import { NodeObject } from '../canvas/fabric/Node';

class GridHandler {
	canvasHandler?: CanvasHandler;

	constructor(canvasHandler: CanvasHandler) {
		this.canvasHandler = canvasHandler;
		this.initialize();
	}

	/**
	 * Init grid
	 *
	 */
	public initialize = () => {
		const { grid, lineColor, borderColor, enabled } = this.canvasHandler.gridOption;
		if (enabled && grid) {
			const width = 5000;
			const gridLength = width / grid;
			const lineOptions = {
				stroke: lineColor,
				selectable: false,
				evented: false,
				id: 'grid',
			};
			for (let i = 0; i < gridLength; i++) {
				const distance = i * grid;
				const fhorizontal = new fabric.Line([distance, -width, distance, width], lineOptions);
				const shorizontal = new fabric.Line([distance - width, -width, distance - width, width], lineOptions);
				this.canvasHandler.canvas.add(fhorizontal);
				this.canvasHandler.canvas.add(shorizontal);
				const fvertical = new fabric.Line([-width, distance - width, width, distance - width], lineOptions);
				const svertical = new fabric.Line([-width, distance, width, distance], lineOptions);
				this.canvasHandler.canvas.add(fvertical);
				this.canvasHandler.canvas.add(svertical);
				if (i % 5 === 0) {
					fhorizontal.set({ stroke: borderColor });
					shorizontal.set({ stroke: borderColor });
					fvertical.set({ stroke: borderColor });
					svertical.set({ stroke: borderColor });
				}
			}
		}
	};

	/**
	 * Set coords in grid
	 * @param {(FabricObject | fabric.ActiveSelection)} target
	 * @returns
	 */
	public setCoords = (target: FabricObject | fabric.ActiveSelection) => {
		const {
			gridOption: { enabled, grid, snapToGrid },
		} = this.canvasHandler;
		if (enabled && grid && snapToGrid) {
			if (target.type === 'activeSelection') {
				const activeSelection = target as fabric.ActiveSelection;
				activeSelection.set({
					left: Math.round(target.left / grid) * grid,
					top: Math.round(target.top / grid) * grid,
				});
				activeSelection.setCoords();
				activeSelection.getObjects().forEach((obj: any) => {
					if (obj.superType === 'node') {
						const left = target.left + obj.left + target.width / 2;
						const top = target.top + obj.top + target.height / 2;
						this.canvasHandler.portHandler.setCoords({ ...obj, left, top });
					}
				});
				return;
			}
			const obj = target as FabricObject;
			obj.set({
				left: Math.round(target.left / grid) * grid,
				top: Math.round(target.top / grid) * grid,
			});
			target.setCoords();
			this.canvasHandler.portHandler.setCoords(target as NodeObject);
		}
	};
}

export default GridHandler;
